export const CATALOG_FILTER_TYPES = {
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
  RANGE: 'range',
  NUMERIC: 'numeric',
};
